<!--suppress XmlHighlighting -->
<div role="navigation" class="full-menu" *ngIf="!isIframe">
    <mat-toolbar color="primary">
        <a href="https://supplyontario--simpplr.vf.force.com/apex/simpplr__app?u=/site/a148Z00000B2KhTQAV/dashboard" matTooltip="Go To: The Source - Enterprise Technology home page."
            [matTooltipPosition]="'right'" class="custom-logo-link"><img ngSrc="assets/logo-en.png" priority
                                                                         alt="Supply Ontario Enterprise Technology Home" height="75"
                                                                         width="200" ></a>
        <h1 class="ctitle">Enterprise Technology Hub <span *ngIf="envLabel">({{envLabel}})</span></h1>
        <div class="user-name-login" *ngIf="loginDisplay"><a [routerLink]="['user-profile']">{{userName}}
                ({{userEmail}})</a></div>
    </mat-toolbar>

    <!--suppress AngularBindingTypeMismatch -->
    <mat-toolbar color="secondary" class="secondary">
        <button type="button" mat-button [routerLink]="['/home']">Home</button>

        <div *ngIf="userType.isUser"><button type="button" mat-button [routerLink]="['/my-work-requests']">My IT Work Requests</button> </div>
        <div *ngIf="globalService.isPMUser"><button type="button" mat-button [routerLink]="['/my-pm-work-requests']">Projects as IT PM
            </button> </div>
            <div *ngIf="globalService.isSponsorUser"><button type="button" mat-button [routerLink]="['/my-sponsored-work-requests']">Sponsored IT Work Requests
            </button> </div>            
        <div class="toolbar-spacer"></div>

        <!-- this dashboard menu is for readonly users and now PMs-->
        <button type="button"  mat-button
            [matMenuTriggerFor]="menuDashBoard">Dashboards<mat-icon>arrow_drop_down</mat-icon></button>
        <mat-menu #menuDashBoard="matMenu">
            <div><button *ngIf="userType.isReadOnly || userType.isAdmin" type="button" mat-button [routerLink]="['statistics']">Statistics</button> </div>
            <div><button type="button" mat-button [routerLink]="['project-dashboard']">Project Dashboard</button> </div>
            <div><button *ngIf="(userType.isReadOnly || userType.isAdmin || globalService.isRestrictedPMUser) && globalService.restrictedProjectCount > 0"  type="button" mat-button [routerLink]="['restricted-project-dashboard']">Restricted Project Dashboard</button> </div>
            <div><button *ngIf="userType.isReadOnly || userType.isAdmin" type="button" mat-button [routerLink]="['non-project-dashboard']">Non-Project
                    Dashboard</button> </div>

        </mat-menu>

        <button type="button" *ngIf="userType.isAdmin" mat-button
            [matMenuTriggerFor]="menuAdmin">Admin<mat-icon>arrow_drop_down</mat-icon></button>
        <mat-menu #menuAdmin="matMenu">

            <div><button type="button" mat-button [routerLink]="['work-requests']">All IT Work
                    Requests</button> </div>
            <div><button type="button" mat-button [routerLink]="['feedback-view']">Feedback Review</button> </div>
 
            <mat-divider> </mat-divider>
              <!--
            <div><button type="button" mat-button [routerLink]="['statistics']">Statistics</button> </div>
            <div><button type="button" mat-button [routerLink]="['project-dashboard']">Project Dashboard</button> </div>
            <div><button type="button" mat-button [routerLink]="['non-project-dashboard']">Non-Project
                    Dashboard</button> </div>
            -->
            <mat-divider> </mat-divider>
            <a target="_blank" href="{{adminGroupUrl}}">
                <button type="button" mat-button>Admin Group Maintenance</button>
            </a>
            <a target="_blank" href="{{readOnlyGroupUrl}}">
                <button type="button" mat-button>Read Only Group Maintenance</button>
            </a>
            <mat-divider> </mat-divider>
            <div class="version">Version: {{appVersion.version}}, git-hash={{appVersion.hash}}</div>

        </mat-menu>
        <div class="loginbuttons">
            <button type="button" mat-raised-button *ngIf="!loginDisplay" (click)="login()">Login</button>
            <button type="button" mat-raised-button color="accent" *ngIf="loginDisplay"
                (click)="logout()">Logout</button>
        </div>
    </mat-toolbar>
</div>
<div role="navigation" class="mini-menu" *ngIf="!isIframe">
    <div class="topnav">
        <a href="#" class="active"><img ngSrc="assets/logo-en.png"
                                            alt="Supply Ontario Home" height="75" width="200" priority></a>
        <div id="myLinks" class="{{miniMenuLinkClass}}">
          <a [routerLink]="['/home']">Home</a>
          <a *ngIf="userType.isUser" [routerLink]="['/my-work-requests']">My IT Work Requests</a>
          <a *ngIf="globalService.isPMUser" [routerLink]="['/my-pm-work-requests']">Projects as IT PM</a>
          <a *ngIf="globalService.isSponsorUser" [routerLink]="['/my-sponsored-work-requests']">Sponsored IT Work Requests</a>
          <a *ngIf="userType.isAdmin" [routerLink]="['/work-requests']">Admin - All IT Work Requests</a>
          <a *ngIf="userType.isAdmin || userType.isReadOnly" [routerLink]="['/statistics']">Statistics</a>
          <a *ngIf="userType.isAdmin || userType.isReadOnly" [routerLink]="['/project-dashboard']">Project Dashboard</a>
          <a *ngIf="userType.isAdmin || userType.isReadOnly" [routerLink]="['/non-project-dashboard']">Non-Project Dashboard</a>
          <a *ngIf="userType.isAdmin" href="{{readOnlyGroupUrl}}">Admin Group Maintenance</a>
          <a *ngIf="userType.isAdmin" href="{{readOnlyGroupUrl}}">Read Only Group Maintenances</a>
        
        </div>
        <a href="javascript:void(0);" class="icon" (click)="showMiniMenuOptions()">
            <mat-icon>menu</mat-icon>
        </a>
      </div>
</div>
<so-alert></so-alert>
<ngx-spinner type="ball-fussion"
    template="<img src='{{spinnerGif}}'>">
    <p [style.color]="'white'"> {{spinnerMessage}} </p>
</ngx-spinner>

<div role="main" class="container">
    <div class="row">
        <div class="col-sm-12">
            <button mat-raised-button id="addWorkRequestBtn" [hidden]="!btnAllowNewRequest" (click)="addWorkRequest()"
                color="primary" type="button" value="submit"><mat-icon>add_box</mat-icon>New IT Work Request
            </button>
        </div>
    </div>
    
    <!--h1>{{ appTitle }}</h1-->
    <!--This is to avoid reload during acquireTokenSilent() because of hidden iframe -->
    <!-- iframe testing is also done in routifng module and base.guard. -->

    <div class="card-body text-center">

        <router-outlet *ngIf="!isIframe"></router-outlet>

    </div>

</div>

<app-project-dashboard  inputDisplayMode="project" *ngIf="dashboardIframe"></app-project-dashboard>
<app-project-dashboard inputDisplayMode="Project List" *ngIf="dashboardListIframe"></app-project-dashboard>
<footer role="contentinfo" *ngIf="loginDisplay && !isIframe">
    <mat-toolbar>
        <div class="footer-text">
            Technical issues or enhancement requests?
            <a href="mailto:{{appEmail}}?subject=Enterprise Technology Work Request Application Support ({{envLabel}})">Supply Ontario Enterprise Technology</a>
        </div>
        
    </mat-toolbar>
</footer>